import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ palette, breakpoints, custom }: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      [breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: 10,
      },
    },
    newStyleRoot: {
      gap: 16,
      marginTop: 16,
      [breakpoints.down('sm')]: {
        flexDirection: 'row',
        gap: 16,
      },
      [breakpoints.down('xs')]: {
        flexDirection: 'column',
        gap: 10,
      },
      '& $doc': {
        color: custom.grey[3],
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '22px',
        marginRight: 0,
      },
    },
    doc: {
      color: palette.primary.main,
      textDecoration: 'none',
      fontSize: 13,
      lineHeight: '14px',
      display: 'flex',
      alignItems: 'center',
      marginRight: 20,
      '&:hover': {
        '& > span': {
          opacity: 0.8,
        },
      },
      '& svg': {
        fontSize: 14,
        marginRight: 8,
        flexShrink: 0,
      },
    },
  });
